import mapValues from 'lodash/mapValues';

import { LoadedWorkflowV8 } from '../migrateTo8';

export type TimeConstraintInstanceV9 = {
  /** Time constraint's UUID */
  id: string;
  /** ID of source task node */
  source: string;
  /** Type of source handle */
  sourceType: 'start' | 'end';
  /** ID of target task node */
  target: string;
  /** Type of target handle */
  targetType: 'start' | 'end';
  /** Minimum duration in seconds, if any */
  minDuration: number | null;
  /** Maximum duration in seconds, if any */
  maxDuration: number | null;
  /** Whether to enable detailed coverage calculation */
  enableDetailedCoverageCalculation: boolean;
  /** Whether to automatically ignore this constraint if it is broken */
  autoIgnoreIfBroken: boolean;
};

export type LoadedWorkflowV9 = Omit<LoadedWorkflowV8, 'graph'> & {
  graph: Omit<LoadedWorkflowV8['graph'], 'timeConstraints'> & {
    timeConstraints: Record<string, TimeConstraintInstanceV9>;
  };
  workcellTransportConfigId?: string;
  workcellTransportConfigType?: 'V1' | 'V3';
  workcellTransportConfigVersion?: number;
};

export const _migrateTo9 = (
  loadedWorkflow: LoadedWorkflowV8
): LoadedWorkflowV9 => {
  return {
    ...loadedWorkflow,
    graph: {
      ...loadedWorkflow.graph,
      timeConstraints: mapValues(
        loadedWorkflow.graph.timeConstraints,
        (tc): TimeConstraintInstanceV9 => ({
          ...tc,
          enableDetailedCoverageCalculation:
            (tc as any).enableDetailedCoverageCalculation ?? false,
          autoIgnoreIfBroken: (tc as any).autoIgnoreIfBroken ?? false,
        })
      ),
    },
  };
};
